module.exports = __webpack_public_path__ + "static/media/n_icon_goback@2x.6b6d17ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_goback@2x.png
// module id = 152
// module chunks = 0 1